import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import PaymentRequestsPage from '@/pages/PaymentRequestsPage';
import CreatePaymentRequest from '@/pages/CreatePaymentRequest';
import PaymentRequestDetail from '@/pages/PaymentRequestDetail';
import VendorsPage from '@/pages/VendorsPage';
import VendorDetail from '@/pages/VendorDetail';
import ContractsPage from '@/pages/ContractsPage';
import ContractForm from '@/pages/ContractForm';
import ContractDetail from '@/pages/ContractDetail';
import AuditTrailPage from '@/pages/AuditTrailPage';
import UpcomingPayments from '@/pages/UpcomingPayments';
import AnalyticsPage from '@/pages/AnalyticsPage';
import SearchResultsPage from '@/pages/SearchResultsPage';
import ReportsPage from '@/pages/ReportsPage';
import DocumentSearchPage from '@/pages/DocumentSearchPage';
import AdminSetupPage from '@/pages/AdminSetupPage';
import '@/App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#0055FF] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-3 text-sm text-[#475569]">Loading...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="payments" element={<PaymentRequestsPage />} />
            <Route path="payments/create" element={<CreatePaymentRequest />} />
            <Route path="payments/:id" element={<PaymentRequestDetail />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="vendors/:id" element={<VendorDetail />} />
            <Route path="contracts" element={<ContractsPage />} />
            <Route path="contracts/create" element={<ContractForm />} />
            <Route path="contracts/:id" element={<ContractDetail />} />
            <Route path="upcoming" element={<UpcomingPayments />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="audit" element={<AuditTrailPage />} />
            <Route path="search" element={<SearchResultsPage />} />
            <Route path="documents" element={<DocumentSearchPage />} />
            <Route path="admin/setup" element={<AdminSetupPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
